import OwaSessionStore from '../store/schema/OwaSessionStore';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import addFolderToDefaultFolderMappings from './addFolderToDefaultFolderMappings';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { ObservableMap } from 'mobx';
import { userConfigurationSet } from './userConfigurationSet';

export interface SetUserConfiguationState {
    store: OwaSessionStore;
}

function initDistinguishedFolderMappings(userConfiguration: OwaUserConfiguration) {
    let sessionSettings = userConfiguration.SessionSettings;
    let defaultFolderNames = sessionSettings.DefaultFolderNames;
    let defaultFolderIds = sessionSettings.DefaultFolderIds;

    if (defaultFolderNames) {
        for (let i = 0; i < defaultFolderNames.length; i++) {
            let defaultFolderName = defaultFolderNames[i];
            if (!defaultFolderName) {
                // Folder list length is longer than the number of populated entries.
                // We're done once we hit an empty entry
                break;
            }

            let folderId = defaultFolderIds[i];
            if (!folderId) {
                // Some default folders we don't have folderId for various reasons (such as permission).
                continue;
            }

            addFolderToDefaultFolderMappings(defaultFolderName, folderId.Id);
        }
    }
}

export default select<SetUserConfiguationState>({
    store: () => store,
})(
    action('setUserConfiguration')(function setUserConfiguration(
        userConfiguration: OwaUserConfiguration,
        mailboxId?: string,
        state?: SetUserConfiguationState
    ): void {
        if (!mailboxId) {
            state.store.userConfiguration = userConfiguration || {};

            initDistinguishedFolderMappings(state.store.userConfiguration);
        } else {
            if (!state.store.connectedAccountsUserConfigurationMap) {
                state.store.connectedAccountsUserConfigurationMap = new ObservableMap({});
            }
            state.store.connectedAccountsUserConfigurationMap.set(
                mailboxId,
                userConfiguration || {}
            );
        }
        userConfigurationSet(userConfiguration, mailboxId);
    })
);
